import type { TCaptureExceptionOptions, TPushData } from './serviceWorker.types'

export enum WINDOW_MESSAGE_TYPE {
  RELOAD_IF_INVISIBLE = 'RELOAD_IF_INVISIBLE',
  CAPTURE_EXCEPTION = 'CAPTURE_EXCEPTION',
}

export const windowMessages = {
  reloadIfInvisible: () => ({ type: WINDOW_MESSAGE_TYPE.RELOAD_IF_INVISIBLE }) as const,
  captureException: ({ error, options }: { error: unknown; options: TCaptureExceptionOptions }) =>
    ({
      type: WINDOW_MESSAGE_TYPE.CAPTURE_EXCEPTION,
      payload: { error, options },
    }) as const,
}

export type TWindowMessage = ReturnType<TObjectValues<typeof windowMessages>>

export enum SW_MESSAGE_TYPE {
  GET_VERSION = 'GET_VERSION',
  GET_NB_WINDOWS = 'GET_NB_WINDOWS',
  SKIP_WAITING = 'SKIP_WAITING',
  MESSAGE_ALL_WINDOWS = 'MESSAGE_ALL_WINDOWS',
  DEBUG_PUSH = 'DEBUG_PUSH',
}

export const swMessages = {
  getVersion: () => ({ type: SW_MESSAGE_TYPE.GET_VERSION }) as const,
  skipWaiting: () => ({ type: SW_MESSAGE_TYPE.SKIP_WAITING }) as const,
  getNbWindows: () => ({ type: SW_MESSAGE_TYPE.GET_NB_WINDOWS }) as const,
  messageAllWindows: (message: TWindowMessage) =>
    ({ type: SW_MESSAGE_TYPE.MESSAGE_ALL_WINDOWS, payload: message }) as const,
  debugPush: (data: TPushData) => ({ type: SW_MESSAGE_TYPE.DEBUG_PUSH, payload: data }) as const,
}

export type TSwMessage = ReturnType<TObjectValues<typeof swMessages>>
